//ParkingMapOnSpotView.js
import React, { useState, useEffect, useRef } from 'react';
import axios from '../api/axiosInstance';
import './ParkingMapOnSpotView.module.css';
import styles from './ParkingMapOnSpotView.module.css';


function ParkingMapOnSpotView({ selectedDates, onSelectSpot, selectedSpot, currentUserId, fullyOccupiedSpots, occupancyData }) {
  const [spots, setSpots] = useState([]);
  const [floors, setFloors] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const mapRef = useRef(null);
  const HOST = process.env.REACT_APP_HOST;
  const PORT = process.env.REACT_APP_API_PORT;
  const baseUrl = `https://${HOST}`;
  const scale_x = 0.6;
  const scale_y = 0.6;


  useEffect(() => {
    const fetchSpots = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/admin/parking-spots`);
        setSpots(res.data);
      } catch (err) {
        console.error("❌ Błąd pobierania miejsc parkingowych:", err);
      }
    };
  
    const fetchFloors = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
  
        const res = await axios.get(`${baseUrl}/api/admin/floors`);
  
        setFloors(res.data);
  
        const stored = localStorage.getItem('selectedFloorOnSpot');
        const defaultFloor = stored || res.data[0];
        setSelectedFloor(defaultFloor);
      } catch (err) {
        console.error("❌ Błąd pobierania pięter:", err);
      }
    };
  
    fetchFloors();
    fetchSpots();
  }, []);
  useEffect(() => {
    if (selectedFloor) {
      localStorage.setItem('selectedFloorOnSpot', selectedFloor);
    }
  }, [selectedFloor]);

  const handleSpotClick = (spot) => {
    if (onSelectSpot) {
      onSelectSpot(selectedSpot && selectedSpot.id === spot.id ? null : spot);
    }
  };
  const getContainerSize = () => {
    const maxX = Math.max(...spots.map(s => s.x_position)) * scale_x + 100;
    const maxY = Math.max(...spots.map(s => s.y_position)) * scale_y + 100;
  
    return {
      width: `${Math.ceil(maxX)}px`,
      height: `${Math.ceil(maxY)}px`
    };
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', position: 'relative' }}>
      <div className={styles['floor-tabs']}>
        {floors.map(floor => (
          <button
            key={floor}
            className={`${styles['floor-tab']} ${selectedFloor === floor ? styles['active'] : ''}`}
            onClick={() => setSelectedFloor(floor)}
          >
            {floor}
          </button>
        ))}
      </div>
      <div className={styles["parking-map-container"]} ref={mapRef} style={getContainerSize()}>
        <div className={styles["parking-map-inner-wrapper"]}>
          {spots
          .filter(spot => spot.floor === selectedFloor)
          .map((spot) => {
            const isSelected = selectedSpot && selectedSpot.id === spot.id;
            const isMine = spot.userId !== undefined && spot.userId === currentUserId;
            const isFullyOccupied = fullyOccupiedSpots.includes(spot.id);
  
            const occupancyInfo = occupancyData.find(o => o.spotId === spot.id);
            const occupancyPercentage = occupancyInfo ? occupancyInfo.occupancyPercentage : 0;
  
            const background = isFullyOccupied
              ? "red"
              : occupancyPercentage > 0
                ? `linear-gradient(to right, red ${occupancyPercentage}%, white ${occupancyPercentage}%)`
                : "white";
  
            const classes = [
              styles["parking-spot-box"],
              isFullyOccupied ? "fully-occupied" : "",
              occupancyPercentage > 0 && !isFullyOccupied ? styles["partially-occupied"] : styles["free"],
              isSelected ? styles["selected"] : ""
            ].join(" ").trim();
  
            return (
              <div
                key={spot.id}
                className={classes}
                style={{
                  left: `${spot.x_position * scale_x}px`,
                  top: `${spot.y_position * scale_y}px`,
                  background
                }}
                onClick={() => handleSpotClick(spot)}
              >
                {spot.spotNumber}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ParkingMapOnSpotView;
